export default "__VITE_ASSET__DY1lOjAG__"